export const setLocalStorage = (name, value) => {
  window.localStorage.setItem(name, value);
};

export const getLocalStorage = (name) => window.localStorage.getItem(name);

export const deleteLocalStorage = (name) => {
  window.localStorage.removeItem(name);
};

export const deleteAllLocalStorage = () => {
  window.localStorage.clear();
}